import React from "react";
import { Helmet } from 'react-helmet';
import { Container } from "react-bootstrap";
import Header from "../Header/Header";

const Page = ({ title, children }) => {

    return (
        <Container className='p-0' fluid>
            <Helmet>
                <title>{title || "Restrito"}</title>
            </Helmet>
            <div style={{ minHeight: '100vh', background: 'radial-gradient(circle at top, #1b2735 0, #090a0f 50%, #020308 100%)' }}>
                <Header />
                <div className="p-3">
                    {children}
                </div>
            </div>
        </Container>
    );
};

export default Page;
